import React from "react";
import {Row, Col, Tooltip} from "antd";
import {InfoCircleOutlined, BankOutlined, BuildOutlined} from "@ant-design/icons";
import {InfoLink, PointerIcon, TooltipText} from "../markerStyles";
import {CourierIcon} from "../../../_defaultComponents/CourierIcon/CourierIcon";

export const Content = ({pickupInfo}) => {
    return (
        <Row>
            <Col>
                <Row justify="space-between">
                    <h4>{pickupInfo.name}</h4>
                    <InfoLink
                        to={{
                            pathname: "/companies/sub-company/" + pickupInfo._id
                        }}
                    >
                        <InfoCircleOutlined />
                    </InfoLink>
                </Row>
                <Row>
                    <PointerIcon>
                        <BankOutlined />
                    </PointerIcon>
                    {pickupInfo.companyName}
                </Row>
                {pickupInfo.region ? (
                    <Row>
                        <PointerIcon>
                            <BuildOutlined />
                        </PointerIcon>
                        {pickupInfo.region}
                    </Row>
                ) : null}
                {pickupInfo.mergingOptions?.map(mergingOption => (
                    <Row>
                        <PointerIcon>
                            <CourierIcon courierType={mergingOption.courierType} />
                        </PointerIcon>
                        <Row>
                            <Tooltip title="Sipariş Tamamlanma Süresi">
                                <TooltipText>{mergingOption.clickToDoorTime}</TooltipText>
                            </Tooltip>
                            <Tooltip title="Sipariş Hazırlama Süresi">
                                <TooltipText>{mergingOption.prepTime}</TooltipText>
                            </Tooltip>
                            <Tooltip title="Birleştirilebilir Zaman Dilimi">
                                <TooltipText>{mergingOption.prepTimeBufferPercent}</TooltipText>
                            </Tooltip>
                            <Tooltip title="Teslimatta Harcanan Süre">
                                <TooltipText>{mergingOption.handOverTime}</TooltipText>
                            </Tooltip>
                            <Tooltip title="Birleştirme Üst Limiti">
                                <TooltipText>{mergingOption.maxOrder}</TooltipText>
                            </Tooltip>
                            <Tooltip title="Toplama Noktası Üst Limiti">
                                <TooltipText>{mergingOption.maxPickup}</TooltipText>
                            </Tooltip>
                        </Row>
                    </Row>
                ))}
            </Col>
        </Row>
    );
};
